import { useState, useRef, useEffect } from "react";
import { Loader } from "../../inc/Fetch";

const SearchUI = ({ data, plugin, searchPluginInstance }) => {
    
    // console.log(data);
    
    const lastKeywordRef = useRef("");
    const [keyword, setKeyword] = useState("");
    const [results, setResults] = useState([]);
    const [currentResult, setCurrentResult] = useState(0);
    
    const handleKeyDown = (e) => {
        if (e.key !== "Enter") return;

        if (e.shiftKey) {
            prevMatch();
            return;
        }

        if (lastKeywordRef.current !== keyword) {
            lastKeywordRef.current = keyword;
            runSearch();
        } else {
            nextMatch();
        }
    };

    const normalizeArabicPdfText = (text = "") => {
        return text
            // Convert Arabic presentation forms into normal letters
            .normalize("NFKC")

            // Remove tatweel
            .replace(/\u0640/g, "")

            // Remove tashkeel
            .replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, "")

            // Normalize common Arabic variations
            .replace(/[إأآٱ]/g, "ا")
            .replace(/[ىئ]/g, "ي")
            .replace(/ؤ/g, "و")
            .replace(/ة/g, "ه")

            // Remove bidi / invisible unicode chars
            .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g, "")

            // Remove repeated tatweel-like junk around letters
            .replace(/[_ـ]+/g, "")

            // Keep Arabic letters, English, numbers, and spaces only
            .replace(/[^\u0621-\u064Aa-zA-Z0-9\s]/g, " ")

            // Collapse spaces
            .replace(/\s+/g, " ")
            .trim();
    };
    
    const runSearch = () => {
        // 1. Clean the user input (remove spaces and diacritics from what they typed)
        const cleanInput = normalizeArabicPdfText(keyword);
        
        const gap = '[\\s\\u0640\\u064B-\\u0652]{0,3}';
        const getCharGroup = (char) => {
        const groups = {
            'ا': '[اأإآٱﺍﺎ]',
            'ب': '[بﺏﺐﺑﺒ]',
            'ت': '[تﺕﺖﺗﺘ]',
            'ث': '[ثﺙﺚﺛﺜ]',
            'ج': '[جﺝﺞﺟﺠ]',
            'ح': '[حﺡﺢﺣﺤ]',
            'خ': '[خﺥﺦﺧﺨ]',
            'د': '[دﺩﺪ]',
            'ذ': '[ذﺫﺬ]',
            'ر': '[رﺭﺮ]',
            'ز': '[زﺯﺰ]',
            'س': '[سﺱﺲﺳﺴ]',
            'ش': '[شﺵﺶﺷﺸ]',
            'ص': '[صﺹﺺﺻﺼ]',
            'ض': '[ضﺽﺾﺿﻀ]',
            'ط': '[طﻁﻂﻃﻄ]',
            'ظ': '[ظﻅﻆﻇﻈ]',
            'ع': '[عﻉﻊﻋﻌ]',
            'غ': '[غﻍﻎﻏﻐ]',
            'ف': '[فﻑﻒﻓﻔ]',
            'ق': '[قﻕﻖﻗﻘ]',
            'ك': '[كﻙﻚﻛﻜ]',
            'ل': '[لﻝﻞﻟﻠ]',
            'م': '[مﻡﻢﻣﻤ]',
            'ن': '[نﻥﻦﻧﻨ]',
            'ه': '[هةﻩﻪﻫﻬ]',
            'و': '[وؤﻭﻮ]',
            'ي': '[يىئﻱﻲﻳﻴ]',
        };

        return groups[char] || char;
    };
        const regexPattern = cleanInput
            .split('')
            .map(char => getCharGroup(char))
            .join(gap);

        const arabicRegex = new RegExp(regexPattern, 'gi');
            
        searchPluginInstance.highlight(arabicRegex);

        const found = [];

        data.forEach((page) => {
            // Normalize the page text for the logical check (IF needed)
            const normalizedPageText = normalizeArabicPdfText(page.text);
            
            
            // We check against the cleanInput because normalizedPageText has no vowels
            if (normalizedPageText.includes(cleanInput)) {
                found.push(page.pageIndex);
            }
        });

        setResults(found);
        setCurrentResult(0);

        if (found.length > 0) {
            // jumpToPage is usually a property of the main viewer instance, 
            // make sure 'plugin' here refers to the file control plugin
            plugin.jumpToPage && plugin.jumpToPage(found[0]);
        }
    };

    const nextMatch = () => {
        if (!results.length) return;

        const next = (currentResult + 1) % results.length;
        setCurrentResult(next);
        plugin.jumpToPage && plugin.jumpToPage(results[next]);
        // searchPluginInstance?.jumpToNextMatch();
    };

    // Navigate previous
    const prevMatch = () => {
        if (!results.length) return;

        const prev =
            (currentResult - 1 + results.length) % results.length;

        setCurrentResult(prev);
        plugin.jumpToPage && plugin.jumpToPage(results[prev]);
    };

    
    if (!data?.length) return <Loader />;

    return (
        <div className="searchBookBox">
            <input
                type="search"
                placeholder="ابحث في الكتاب..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                    padding: 6,
                    width: 250,
                    direction: "rtl",
                }}
            />
        </div>
    );
};

export default SearchUI;